import { actions } from '../../actions/actionTypes'

const initialState = {
  pageNumber: 1,
  numPages: null,
  scale: 1
}

const viewer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_NUM_PAGES:
      return {
        ...state,
        numPages: action.payload
      }
    case actions.INCREMENT_PAGE:
      return {
        ...state,
        pageNumber: state.pageNumber + 1
      }
    case actions.DECREMENT_PAGE:
      return {
        ...state,
        pageNumber: state.pageNumber - 1
      }
    case actions.SCALE_UP:
      return {
        ...state,
        scale: state.scale + 0.2
      }
    case actions.SCALE_DOWN:
      return {
        ...state,
        scale: state.scale - 0.2
      }
    default:
      return state
  }
}

export default viewer
